module.exports = __webpack_public_path__ + "img/map-act.660a6d6c.png";